import { EmployeeRowStatus } from '../types';

/** Error always wins over warning so a row can never look fine while blocking submit. */
export const getEmployeeRowStatus = (
  errorCount: number,
  warningCount: number
): EmployeeRowStatus => {
  if (errorCount > 0) {
    return 'error';
  }
  return warningCount > 0 ? 'warning' : 'valid';
};
